import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

// ID from amplitude experiment - https://app.eu.amplitude.com/experiment/rynekpierwotny-622997/100039510/config/10218177/settings
export const SEMANTIC_SEARCH_AB_TEST_ID = "semantic-search";

const SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT = "default" as const;
export const SEMANTIC_SEARCH_NEW_FLOW_VARIANT = "new-flow" as const;

export const semanticSearchAbTests: IABTestConfiguration = {
    id: SEMANTIC_SEARCH_AB_TEST_ID,
    name: OngoingABTests.SEMANTIC_SEARCH,
    expires: new Date(2027, 11, 31), // Set actual date
    // Homepage button and offer list floating sidebar
    path: [rpAppPath.base, rpAppPath.friendlyOfferList],
    variants: [SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT, SEMANTIC_SEARCH_NEW_FLOW_VARIANT],
    withSSR: true,
    useAmplitude: true,
    matchOnAllPaths: false
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

// ID from amplitude experiment - https://app.eu.amplitude.com/experiment/rynekpierwotny-622997/100039510/config/10218177/settings
export const SEMANTIC_SEARCH_AB_TEST_ID = "semantic-search";

const SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT = "default" as const;
export const SEMANTIC_SEARCH_NEW_FLOW_VARIANT = "new-flow" as const;

export const semanticSearchAbTests: IABTestConfiguration = {
    id: SEMANTIC_SEARCH_AB_TEST_ID,
    name: OngoingABTests.SEMANTIC_SEARCH,
    expires: new Date(2027, 11, 31), // Set actual date
    // Homepage button and offer list floating sidebar
    path: [rpAppPath.base, rpAppPath.friendlyOfferList],
    variants: [SEMANTIC_SEARCH_NEW_FLOW_DEFAULT_VARIANT, SEMANTIC_SEARCH_NEW_FLOW_VARIANT],
    withSSR: true,
    useAmplitude: true,
    matchOnAllPaths: false
};
